import {
  ApiTabTypeProps,
  FileRoleTypeProps,
} from '@/common/types/ApiResponseTypes.type';

export const AdditionalApiUrlCreator = ({
  TabType,
  userType: fileType,
  id,
}: FileRoleTypeProps & ApiTabTypeProps & { id: number | string }) => {
  switch (fileType) {
    case 'damaged':
      return `/property/reports/${id}/accident_users/damaged/adjuster/images/additional/${TabType}/`;
    case 'culprit':
      return `/property/reports/${id}/accident_users/culprit/adjuster/images/additional/${TabType}/`;
    case 'body':
      return `/body/reports/${id}/images/adjuster/additional/${TabType}/`;
    case 'initial':
      return `/initial/reports/${id}/images/adjuster/${TabType}/additional/`;

    default:
      return '';
  }
};
